/* EcomChief v2 — collection: fit, search, sort, compare. Needs ec-v2.js. */
(function () {
  'use strict';
  var E = window.ECX;
  if (!E) return;
  var $ = E.$, $$ = E.$$, esc = E.esc, money = E.money, toast = E.toast, Overlay = E.Overlay, reduce = E.reduce, root = E.root;
  /* ======================================================================
     FIT — score per business model from the card's time/ease scores.
     ====================================================================== */
  var SKILL_MODEL = { video: ['drop'], write: ['amazon', 'affiliate'], talk: ['agency'], tools: ['app'] };
  function fitScore(model, t, e, skill, hours) {
    if (!skill || !hours || !t || model === 'bundle' || model === 'other') return null;
    var sk = skill === 'unsure' ? Math.round(e * 0.72) : ((SKILL_MODEL[skill] || []).indexOf(model) > -1 ? 58 : 16);
    var cap = { low: 42, med: 72, high: 100 }[hours];
    var hs = t <= cap ? 40 - (cap - t) * 0.12 : Math.max(0, 40 - (t - cap) * 0.85);
    return Math.max(8, Math.min(97, Math.round(sk + hs)));
  }

  /* ======================================================================
     SHOP — collection page
     ====================================================================== */
  class EcxShop extends HTMLElement {
    connectedCallback() {
      this.cards = $$('[data-card]', this);
      this.grid = $('[data-grid]', this);
      this.state = { skill: '', hours: '', sort: 'original', great: false, hideOut: false, q: '', business: '', cmp: [], f: { type: [], ind: [], price: [] } };
      this.labels = JSON.parse(($('[data-shop-strings]', this) || {}).textContent || '{}');
      this.cards.forEach(function (c, i) { c.dataset.i = i; });
      this.facets();
      if (this.classList.contains('is-all-catalog')) this.setupBusinessTypes();
      if (this.classList.contains('is-saas')) this.setupSoftwareBrowse();
      this.setupProgressive();
      this.bind();
      this.fromUrl();
      this.sizeSelects();
      this.draw();
      this.seo();
      var self = this;
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { self.sizeSelects(); });
      this.onResize = this.sizeSelects.bind(this);
      window.addEventListener('resize', this.onResize);
    }
    disconnectedCallback() {
      window.removeEventListener('resize', this.onResize);
      if (this.onSoftwareFilterDismiss) {
        document.removeEventListener('click', this.onSoftwareFilterDismiss);
        document.removeEventListener('keydown', this.onSoftwareFilterDismiss);
      }
    }

    /* Software collection only: collapsible secondary filters and progressive results. */
    setupSoftwareBrowse() {
      var self = this;
      $$('[data-fg="ind"], [data-fg="price"]', this).forEach(function (group, index) {
        if (group.hidden) return;
        var legend = $('legend', group);
        if (!legend) return;
        var panel = document.createElement('div');
        panel.className = 'ecx-fg__content';
        panel.id = self.id + '-facet-panel-' + index;
        Array.from(group.children).forEach(function (child) {
          if (child !== legend) panel.appendChild(child);
        });
        group.appendChild(panel);
        var label = legend.textContent.trim();
        legend.textContent = '';
        var toggle = document.createElement('button');
        toggle.type = 'button';
        toggle.className = 'ecx-fg__toggle';
        toggle.setAttribute('aria-controls', panel.id);
        var title = document.createElement('span');
        title.textContent = label;
        toggle.appendChild(title);
        var arrow = document.createElement('i');
        arrow.setAttribute('aria-hidden', 'true');
        toggle.appendChild(arrow);
        legend.appendChild(toggle);
        /* Keep the price chart visible during its initial bar-height calculation. */
        var isPrice = group.dataset.fg === 'price';
        var isOpen = isPrice || !!$('input:checked', panel);
        panel.hidden = !isOpen;
        toggle.setAttribute('aria-expanded', String(isOpen));
        toggle.addEventListener('click', function () {
          isOpen = !isOpen;
          panel.hidden = !isOpen;
          toggle.setAttribute('aria-expanded', String(isOpen));
          /* Recalculate chart bars only after the histogram becomes visible again. */
          if (isOpen && isPrice) {
            requestAnimationFrame(function () { self.drawFacets(); });
          }
        });
      });
      /* Overlay.close() runs on document click/keydown, so the queued
         reposition occurs after the buyer chooses Show, X, backdrop, or Esc. */
      this.onSoftwareFilterDismiss = function (e) {
        if (!self._resultsScrollPending) return;
        if (e.type === 'click' && !(e.target.closest && e.target.closest('[data-rail] [data-ecx-close], [data-ecx-scrim]'))) return;
        if (e.type === 'keydown' && e.key !== 'Escape') return;
        self._resultsScrollPending = false;
        requestAnimationFrame(function () { self.scrollToSoftwareResults(); });
      };
      document.addEventListener('click', this.onSoftwareFilterDismiss);
      document.addEventListener('keydown', this.onSoftwareFilterDismiss);
    }

    /* Every collection: show results in batches (a long catalogue was one
       60,000px scroll on phones). Filters, search and sort still run over the
       full set; only the number of visible cards is capped. */
    setupProgressive() {
      var self = this;
      var saas = this.classList.contains('is-saas');
      this.pageSize = saas ? 18 : (window.matchMedia('(max-width: 640px)').matches ? 12 : 24);
      this.moreNoun = saas ? 'software businesses' : 'businesses';
      if (!this.grid || this.cards.length <= this.pageSize) return;
      this.visibleLimit = this.pageSize;
      var row = document.createElement('div');
      row.className = 'ecx-load';
      row.hidden = true;
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'ecx-btn ecx-btn--line';
      button.textContent = 'Show more ' + this.moreNoun;
      row.appendChild(button);
      this.grid.insertAdjacentElement('afterend', row);
      this.loadMoreWrap = row;
      this.loadMoreButton = button;
      button.addEventListener('click', function () {
        var first = self.visibleLimit;
        self.visibleLimit += self.pageSize;
        self.draw();
        /* keep keyboard / screen-reader users in place: focus the first new card's link */
        var shown = self.cards.filter(function (c) { return !c.hidden; });
        var card = shown[first];
        var next = card && (card.querySelector('h2 a') || card.querySelector('h3 a'));
        if (next) next.focus({ preventScroll: true });
      });
    }

    /* Software-only scroll correction: after filters change, land at the results
       count heading rather than halfway through the cards or at the hero.
       Defer scrolling while the mobile filter drawer is open. */
    scrollToSoftwareResults() {
      if (!this.classList.contains('is-saas')) return;
      var rail = $('[data-rail]', this);
      if (rail && rail.classList.contains('is-open')) {
        this._resultsScrollPending = true;
        return;
      }
      this._resultsScrollPending = false;
      var self = this, seq = this._resultsScrollSeq = (this._resultsScrollSeq || 0) + 1;
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          if (self._resultsScrollSeq !== seq || !self.isConnected) return;
          var heading = $('.ecx-top h2', self);
          if (!heading) return;
          var header = document.querySelector('[data-ecx-hdr]');
          var headerHeight = header ? header.getBoundingClientRect().height : 0;
          var mobile = window.matchMedia('(max-width: 1080px)').matches;
          var filterBar = mobile ? $('.ecx-fitbar', self) : null;
          var filterHeight = filterBar ? filterBar.getBoundingClientRect().height + 16 : 0;
          var top = window.scrollY + heading.getBoundingClientRect().top - headerHeight - filterHeight - 20;
          window.scrollTo({ top: Math.max(0, Math.round(top)), behavior: reduce ? 'auto' : 'smooth' });
        });
      });
    }

    /* All-businesses page only: browse by real Shopify collection membership. */
    setupBusinessTypes() {
      var self = this, inputs = $$('[data-business-type]', this);
      if (!inputs.length) return;
      var param = new URLSearchParams(window.location.search).get('business');
      var requested = inputs.find(function (input) { return input.value === param; });
      if (requested) {
        requested.checked = true;
        this.state.business = requested.value;
      }
      inputs.forEach(function (input) {
        input.addEventListener('change', function () {
          if (!input.checked) return;
          /* If the catalogue outgrows one Shopify page, use the full collection. */
          if (self.dataset.catalogOverflow === 'true' && input.value && input.dataset.businessUrl) {
            window.location.assign(input.dataset.businessUrl);
            return;
          }
          self.state.business = input.value;
          self.draw();
          if (window.history.replaceState) {
            var url = new URL(window.location.href);
            if (input.value) url.searchParams.set('business', input.value);
            else url.searchParams.delete('business');
            url.searchParams.delete('page');
            window.history.replaceState({}, '', url.toString());
          }
          var gridTop = $('[data-count]', self);
          if (gridTop && window.matchMedia('(max-width: 1080px)').matches) {
            var drawer = $('[data-rail]', self);
            if (drawer && drawer.classList.contains('is-open')) {
              /* Keep the mobile drawer open until the buyer presses Show. */
            }
          }
        });
      });
    }
    bind() {
      var self = this, s = this.state;
      ['skill', 'hours'].forEach(function (k) {
        var el = $('[data-fit="' + k + '"]', self);
        if (!el) return;
        el.addEventListener('change', function () {
          s[k] = el.value; el.classList.remove('is-empty');
          if (s.skill && s.hours) { s.sort = 'best'; var so = $('[data-sort]', self); if (so) so.value = 'best'; }
          self.sizeSelects(); self.draw(); self.scrollToSoftwareResults();
        });
      });
      var sort = $('[data-sort]', this);
      if (sort) sort.addEventListener('change', function () { s.sort = sort.value; self.draw(); });
      var g = $('[data-great]', this); if (g) g.addEventListener('change', function () { s.great = g.checked; self.draw(); self.scrollToSoftwareResults(); });
      var h = $('[data-hideout]', this); if (h) h.addEventListener('change', function () { s.hideOut = h.checked; self.draw(); self.scrollToSoftwareResults(); });
      var q = $('[data-q]', this), qt;
      if (q) q.addEventListener('input', function () { clearTimeout(qt); qt = setTimeout(function () { s.q = q.value.trim().toLowerCase(); self.draw(); }, 120); });
      var openRail = $('[data-rail-open]', this);
      if (openRail) openRail.addEventListener('click', function () { Overlay.open($('[data-rail]', self), '[data-fit="skill"]'); setTimeout(function () { self.sizeSelects(); }, 60); });
      this.addEventListener('change', function (e) {
        var cb = e.target.closest('[data-cmp]');
        if (!cb) return;
        var id = cb.value, i = s.cmp.indexOf(id);
        if (cb.checked && i < 0) { if (s.cmp.length >= 3) { cb.checked = false; toast(self.labels.max3 || 'Compare up to 3 at a time'); return; } s.cmp.push(id); }
        if (!cb.checked && i > -1) s.cmp.splice(i, 1);
        self.tray();
      });
      var go = $('[data-tray-go]', this); if (go) go.addEventListener('click', function () { self.compare(); });
      var clr = $('[data-tray-clear]', this);
      if (clr) clr.addEventListener('click', function () { s.cmp = []; $$('[data-cmp]', self).forEach(function (c) { c.checked = false; }); self.tray(); });
    }
    fromUrl() {
      var q = new URLSearchParams(window.location.search), s = this.state, self = this;
      ['skill', 'hours'].forEach(function (k) {
        var v = (q.get(k) || '').replace(/[^a-z]/g, ''), el = $('[data-fit="' + k + '"]', self);
        if (!v || !el || !$('option[value="' + v + '"]', el)) return;
        el.value = v; el.classList.remove('is-empty'); s[k] = v;
      });
      if (s.skill && s.hours) { s.sort = 'best'; var so = $('[data-sort]', this); if (so) so.value = 'best'; }
    }
    seo() {
      var body = $('[data-seo]', this), btn = $('[data-seo-more]', this);
      if (!body || !btn || body.scrollHeight < 220) return;
      var more = btn.textContent;
      body.classList.add('is-clamped');
      btn.hidden = false;
      btn.addEventListener('click', function () {
        var open = body.classList.toggle('is-clamped') === false;
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        btn.textContent = open ? btn.dataset.less : more;
      });
    }
    sizeSelects() {
      var h = $('[data-sentence]', this);
      if (!h || !h.offsetParent) return;
      var m = $('.ecx-measure', h);
      if (!m) { m = document.createElement('span'); m.className = 'ecx-measure'; m.setAttribute('aria-hidden', 'true'); h.appendChild(m); }
      var fs = parseFloat(getComputedStyle(h).fontSize);
      $$('select', h).forEach(function (sel) { m.textContent = sel.options[sel.selectedIndex].text; sel.style.width = Math.ceil(m.getBoundingClientRect().width + fs * 0.8) + 'px'; });
    }
    fit(c) { return fitScore(c.dataset.model, +c.dataset.t, +c.dataset.e, this.state.skill, this.state.hours); }
    draw() {
      var s = this.state, self = this, L = this.labels, visible = [];
      this.cards.forEach(function (c) {
        var f = self.fit(c), show = true;
        if (s.hideOut && c.dataset.status !== 'available') show = false;
        if (s.q && c.dataset.search.indexOf(s.q) < 0) show = false;
        if (s.business && (c.dataset.businessCollections || '').indexOf('|' + s.business + '|') < 0) show = false;
        if (s.great && (f === null || f < 82)) show = false;
        if (show && !self.passFacets(c, null)) show = false;
        c.hidden = !show;
        var pill = $('[data-fitpill]', c);
        if (pill) {
          if (f === null) pill.hidden = true;
          else {
            pill.hidden = false;
            var circ = 2 * Math.PI * 9;
            $('.v', pill).setAttribute('stroke-dashoffset', (circ * (1 - f / 100)).toFixed(1));
            $('[data-fitword]', pill).textContent = f >= 82 ? L.great : f >= 60 ? L.good : L.stretch;
          }
        }
        if (show) visible.push(c);
      });
      var mode = s.sort === 'best' && (!s.skill || !s.hours) ? 'original' : s.sort;
      var all = this.cards.slice().sort(function (a, b) {
        var r = 0;
        if (mode === 'best') r = (self.fit(b) || 0) - (self.fit(a) || 0) || (+b.dataset.reviews) - (+a.dataset.reviews);
        else if (mode === 'reviews') r = (+b.dataset.reviews) - (+a.dataset.reviews);
        else if (mode === 'rating') r = (+b.dataset.rating) - (+a.dataset.rating) || (+b.dataset.reviews) - (+a.dataset.reviews);
        else if (mode === 'price') r = (+a.dataset.price) - (+b.dataset.price);
        else r = (+a.dataset.i) - (+b.dataset.i);
        if (r === 0) r = (+a.dataset.i) - (+b.dataset.i);
        var av = (b.dataset.status === 'available' ? 1 : 0) - (a.dataset.status === 'available' ? 1 : 0);
        return av || r;
      });
      all.forEach(function (c) { self.grid.appendChild(c); });
      if (this.loadMoreWrap) {
        var criteria = JSON.stringify([s.skill, s.hours, s.sort, s.great, s.hideOut, s.q, s.f, s.business]);
        if (this._softwareCriteria !== criteria) this.visibleLimit = this.pageSize;
        this._softwareCriteria = criteria;
        var shown = 0;
        all.forEach(function (c) {
          if (!c.hidden) {
            if (shown >= self.visibleLimit) c.hidden = true;
            shown++;
          }
        });
        var remaining = Math.max(0, visible.length - this.visibleLimit);
        this.loadMoreWrap.hidden = remaining === 0;
        this.loadMoreButton.textContent = 'Show ' + Math.min(this.pageSize, remaining) + ' more ' + this.moreNoun;
      }
      var empty = $('[data-empty]', this);
      if (empty) { empty.hidden = visible.length > 0; this.grid.appendChild(empty); }
      var cnt = $('[data-count]', this); if (cnt) cnt.textContent = visible.length;
      var cl = $('[data-count-label]', this); if (cl) cl.textContent = visible.length === 1 ? L.one : L.many;
      var cd = $('[data-count-done]', this); if (cd) cd.textContent = visible.length;
      var cdl = $('[data-count-done-label]', this); if (cdl) cdl.textContent = (visible.length === 1 ? L.one : L.many).trim();
      this.drawFacets();
      var v = $('[data-verdict]', this), fb = $('[data-fitbar]', this);
      if (s.skill && s.hours) {
        var great = this.cards.filter(function (c) { var f = self.fit(c); return f !== null && f >= 82 && c.dataset.status === 'available'; });
        var top = this.cards.filter(function (c) { return c.dataset.status === 'available' && self.fit(c) !== null; }).sort(function (a, b) { return self.fit(b) - self.fit(a) || (+b.dataset.reviews) - (+a.dataset.reviews); })[0];
        if (v) v.innerHTML = '<b>' + great.length + ' ' + esc(L.greatFits) + '.</b> ' + (top ? esc(L.closest) + ' <b>' + esc(top.dataset.name) + '</b>, ' + esc(L.sorted) : '');
        if (fb) fb.innerHTML = '<b>' + great.length + ' ' + esc(L.greatFits) + '</b> ' + esc(L.forYou);
      } else {
        if (v) v.textContent = L.prompt;
        if (fb) fb.innerHTML = esc(L.barPrompt);
      }
    }
    /* ======================================================================
       FACETS — software type, industry (from product metafields) and price
       bands (from the cards' prices). OR within a group, AND across groups.
       Counts show what each choice would return with everything else applied.
       ====================================================================== */
    facets() {
      var self = this, box = $('[data-facets]', this);
      this.fbox = box;
      if (!box) return;
      this.cards.forEach(function (c) {
        c._f = { type: (c.dataset.fType || '').split('¦').filter(Boolean), ind: (c.dataset.fInd || '').split('¦').filter(Boolean) };
      });
      /* price bands: one per distinct starting price, merged into at most 5 */
      var prices = this.cards.map(function (c) { return +c.dataset.price; }).filter(function (p) { return p > 0; });
      var uniq = prices.filter(function (p, i) { return prices.indexOf(p) === i; }).sort(function (a, b) { return a - b; });
      var bands = [];
      if (uniq.length > 5) {
        var per = Math.ceil(uniq.length / 5);
        for (var i = 0; i < uniq.length; i += per) bands.push([uniq[i], uniq[Math.min(i + per, uniq.length) - 1]]);
      } else uniq.forEach(function (p) { bands.push([p, p]); });
      this.bands = bands;
      var hist = $('[data-hist]', box), fg = hist && hist.closest('[data-fg]');
      if (hist && bands.length >= 3) {
        hist.innerHTML = bands.map(function (b, i) {
          var label = b[0] === b[1] ? money(b[0]) : money(b[0]) + '–' + money(b[1]);
          return '<label class="ecx-hbar"><input type="checkbox" value="' + i + '" data-f="price"><span class="ecx-hbar__col"><i data-fbar></i></span><b class="ecx-num">' + esc(label) + '</b><small data-fcount></small><span class="ecx-vh"> ' + esc(self.labels.fPrice || 'Price') + '</span></label>';
        }).join('');
      } else if (fg) fg.hidden = true;
      this.cards.forEach(function (c) {
        var p = +c.dataset.price;
        c._f.price = bands.map(function (b, i) { return p >= b[0] && p <= b[1] ? String(i) : null; }).filter(Boolean);
      });
      box.addEventListener('change', function (e) {
        var cb = e.target.closest('[data-f]');
        if (!cb) return;
        var list = self.state.f[cb.dataset.f], i = list.indexOf(cb.value);
        if (cb.checked && i < 0) list.push(cb.value);
        if (!cb.checked && i > -1) list.splice(i, 1);
        self.draw(); self.toUrl(); self.scrollToSoftwareResults();
      });
      var more = $('[data-fmore-btn]', box);
      if (more) {
        var label = more.textContent;
        more.addEventListener('click', function () {
          var open = more.getAttribute('aria-expanded') !== 'true';
          $$('[data-fmore]', box).forEach(function (li) { li.hidden = !open; });
          more.setAttribute('aria-expanded', open ? 'true' : 'false');
          more.textContent = open ? more.dataset.less : label;
        });
      }
      var clr = $('[data-facet-clear]', box);
      if (clr) clr.addEventListener('click', function () { self.clearFacets(); });
      var act = $('[data-active]', this);
      if (act) act.addEventListener('click', function (e) {
        var b = e.target.closest('[data-unset]');
        if (b) { var parts = b.dataset.unset.split(':'); self.setFacet(parts[0], parts.slice(1).join(':'), false); }
        if (e.target.closest('[data-clear-all]')) self.clearFacets();
      });
      /* deep links: ?type=crm&industry=home-services&price=199 */
      var q = new URLSearchParams(window.location.search), slug = function (v) { return String(v).toLowerCase().replace(/&/g, 'and').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, ''); };
      [['type', 'type'], ['ind', 'industry']].forEach(function (pair) {
        (q.get(pair[1]) || '').split(',').filter(Boolean).forEach(function (want) {
          $$('[data-f="' + pair[0] + '"]', box).forEach(function (cb) { if (slug(cb.value) === want) { cb.checked = true; self.state.f[pair[0]].push(cb.value); } });
        });
      });
      (q.get('price') || '').split(',').filter(Boolean).forEach(function (want) {
        bands.forEach(function (b, i) { if (String(b[0] / 100) === want) { var cb = $('[data-f="price"][value="' + i + '"]', box); if (cb) { cb.checked = true; self.state.f.price.push(String(i)); } } });
      });
      this.slug = slug;
    }
    passFacets(c, skip) {
      if (!this.fbox || !c._f) return true;
      var f = this.state.f;
      return ['type', 'ind', 'price'].every(function (k) {
        if (k === skip || !f[k].length) return true;
        return c._f[k].some(function (v) { return f[k].indexOf(v) > -1; });
      });
    }
    setFacet(k, v, on) {
      var cb = $('[data-f="' + k + '"][value="' + (window.CSS && CSS.escape ? CSS.escape(v) : v) + '"]', this.fbox);
      if (cb) { cb.checked = on; cb.dispatchEvent(new Event('change', { bubbles: true })); }
    }
    clearFacets() {
      var f = this.state.f;
      f.type = []; f.ind = []; f.price = [];
      $$('[data-f]', this.fbox).forEach(function (cb) { cb.checked = false; });
      this.draw(); this.toUrl(); this.scrollToSoftwareResults();
    }
    toUrl() {
      if (!this.fbox || !window.history.replaceState) return;
      var self = this, u = new URL(window.location.href), f = this.state.f;
      var put = function (key, vals) { if (vals.length) u.searchParams.set(key, vals.join(',')); else u.searchParams.delete(key); };
      put('type', f.type.map(this.slug));
      put('industry', f.ind.map(this.slug));
      put('price', f.price.map(function (i) { return String(self.bands[+i][0] / 100); }));
      window.history.replaceState({}, '', u.toString());
    }
    drawFacets() {
      if (!this.fbox) return;
      var self = this, s = this.state, f = s.f, L = this.labels;
      /* live counts: every other filter applied, this group ignored */
      var base = this.cards.filter(function (c) {
        if (s.hideOut && c.dataset.status !== 'available') return false;
        if (s.q && c.dataset.search.indexOf(s.q) < 0) return false;
        var fit = self.fit(c);
        if (s.great && (fit === null || fit < 82)) return false;
        return true;
      });
      var maxBand = 1;
      ['type', 'ind', 'price'].forEach(function (k) {
        var pool = base.filter(function (c) { return self.passFacets(c, k); });
        $$('[data-f="' + k + '"]', self.fbox).forEach(function (cb) {
          var n = pool.filter(function (c) { return c._f[k].indexOf(cb.value) > -1; }).length;
          var row = cb.closest('label'), out = $('[data-fcount]', row);
          if (out) out.textContent = n;
          row.classList.toggle('is-zero', n === 0 && !cb.checked);
          cb.disabled = n === 0 && !cb.checked;
          if (k === 'price') { row._n = n; maxBand = Math.max(maxBand, n); }
        });
      });
      $$('[data-f="price"]', this.fbox).forEach(function (cb) {
        var row = cb.closest('label'), bar = $('[data-fbar]', row);
        if (bar) bar.style.height = Math.max(6, Math.round((row._n || 0) / maxBand * 100)) + '%';
      });
      var total = f.type.length + f.ind.length + f.price.length;
      var clr = $('[data-facet-clear]', this.fbox); if (clr) clr.hidden = !total;
      var badge = $('[data-fbadge]', this); if (badge) { badge.hidden = !total; badge.textContent = total; }
      var act = $('[data-active]', this);
      if (act) {
        var chip = function (k, v, label) { return '<button type="button" class="ecx-achip" data-unset="' + esc(k + ':' + v) + '"><span>' + esc(label) + '</span><span aria-hidden="true">✕</span><span class="ecx-vh"> ' + esc(L.remove || 'Remove filter') + '</span></button>'; };
        var html = f.type.map(function (v) { return chip('type', v, v); }).concat(f.ind.map(function (v) { return chip('ind', v, v); }))
          .concat(f.price.map(function (i) { var b = self.bands[+i]; return chip('price', i, b[0] === b[1] ? money(b[0]) : money(b[0]) + '–' + money(b[1])); }));
        act.innerHTML = html.join('') + (total ? '<button type="button" class="ecx-aclear" data-clear-all>' + esc(L.clearAll || 'Clear all') + '</button>' : '');
        act.hidden = !total;
      }
    }
    tray() {
      var t = $('[data-tray]', this), s = this.state, self = this;
      if (!t) return;
      if (!s.cmp.length) { t.classList.remove('is-on'); return; }
      $('[data-tray-th]', t).innerHTML = s.cmp.map(function (id) { var c = $('[data-card][data-id="' + id + '"]', self); return c ? '<img src="' + esc(c.dataset.thumb) + '" alt="" width="38" height="38">' : ''; }).join('');
      $('[data-tray-t]', t).textContent = s.cmp.length === 1 ? this.labels.pickOne : s.cmp.length + ' ' + this.labels.selected;
      $('[data-tray-go]', t).disabled = s.cmp.length < 2;
      t.classList.add('is-on');
    }
    compare() {
      var self = this, L = this.labels;
      var cs = this.state.cmp.map(function (id) { return $('[data-card][data-id="' + id + '"]', self); }).filter(Boolean);
      var fits = cs.map(function (c) { return self.fit(c); });
      var best = Math.max.apply(null, fits.map(function (f) { return f || 0; }));
      var minT = Math.min.apply(null, cs.map(function (c) { return +c.dataset.t || 999; }));
      function band(t) { return t >= 85 ? L.t_high : t >= 50 ? L.t_med : L.t_low; }
      function word(e) { return e >= 77 ? L.high : e >= 55 ? L.medium : L.low; }
      var rows = [
        [L.r_type, function (c) { return esc(c.dataset.modelLabel); }],
        [L.r_get, function (c) { return esc(c.dataset.platform); }],
        [L.r_time, function (c) { var t = +c.dataset.t; return t ? '<span class="' + (t === minT ? 'win' : '') + '">' + esc(band(t)) + '</span>' : esc(L.varies); }],
        [L.r_ease, function (c) { var e = +c.dataset.e; return e ? esc(word(e)) : esc(L.varies); }],
        [L.r_price, function (c) { return esc(c.dataset.priceLabel); }],
        [L.r_fit, function (c, i) { var f = fits[i]; return f === null ? esc(L.finish) : '<span class="' + (f === best ? 'win' : '') + '">' + esc(f >= 82 ? L.great : f >= 60 ? L.good : L.stretch) + '</span>'; }],
        [L.r_avail, function (c) { return c.dataset.status === 'available' ? esc(L.yes) : esc(L.soldOut); }]
      ];
      var html = '<table class="ecx-ctable"><thead><tr><th></th>' + cs.map(function (c) { return '<th><img src="' + esc(c.dataset.img) + '" alt="" width="400" height="300" loading="lazy"><b>' + esc(c.dataset.name) + '</b></th>'; }).join('') + '</tr></thead><tbody>' +
        rows.map(function (r) { return '<tr><th scope="row">' + esc(r[0]) + '</th>' + cs.map(function (c, i) { return '<td>' + r[1](c, i) + '</td>'; }).join('') + '</tr>'; }).join('') +
        '<tr><th></th>' + cs.map(function (c) { return '<td><a class="ecx-btn ecx-btn--line ecx-btn--sm" href="' + esc(c.dataset.url) + '">' + esc(L.view) + '</a></td>'; }).join('') + '</tr></tbody></table>';
      var m = $('[data-cmp-modal]', this);
      $('[data-cmp-body]', m).innerHTML = html;
      Overlay.open(m);
    }
  }
  if (!customElements.get('ecx-shop')) customElements.define('ecx-shop', EcxShop);
})();
